import SectionHeading from "./sectionHeading";

export default SectionHeading;
